
import { Component, Vue, Prop } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { UserModule } from '@/store/modules/user';
import { OrderTaskStage } from '@/types/orderTask';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import draggable from 'vuedraggable';
import SearchItem from './TaskSearchItem.vue';

@Component({
  name: 'TaskSearch',
  components: {
    SearchItem,
    draggable
  }
})
export default class extends Vue {
  @Prop({
    default: OrderTaskStage.Task_STAGE_ALL,
    validator: (value) => OrderTaskStage !== undefined
  })
  private stage!: OrderTaskStage;

  private isToggle = false
  private checkList: any = []
  private searchArray: any = []
  private showSearchArray: any = []
  private taskForm: any = {
    number: '',
    dateRange: [new Date().getTime() - 1000 * 60 * 60 * 24 * this.getManyDays(), new Date().getTime()],
    finishDateRange: '',
    troubleDescrible:'',
    repairMan: '',
    customerDept: {},
    person: '',
    contactWay: '',
    address: '',
    customer: {},
    servicerDept: {},
    designee: '',
    dealWay: '',
    taskStatus: '',
    orderStatus: '',
    logistics: '',
    logisticsNumber: '',
    workOrderNum: '',
    faultType: '',
    faultPhenomenon: '',
    tag: '',
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private searchKey = ''
  private visiblePopover = false

  created() {
    this.searchKey = 'lsjl_search' + this.$route.path;
    let index = this.searchKey.lastIndexOf('/');
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        if (localParse[p].id === '1') {
          localParse[p].fields = [new Date().getTime() - 1000 * 60 * 60 * 24 * this.getManyDays(), new Date().getTime()];
        } else {
          localParse[p].fields = ''
        }
      }
      this.searchArray = localParse;
      // 兼容历史本地缓存：无完成日期项时插入到指派日期后面
      if (!localParse.some((item: any) => item.id === '22')) {
        const finishItem = { fields: '', name: '完成日期', id: '22', checked: true, show: true };
        const appointIndex = localParse.findIndex((item: any) => item.id === '1');
        if (appointIndex > -1) {
          localParse.splice(appointIndex + 1, 0, finishItem);
        } else {
          localParse.push(finishItem);
        }
      }
    } else {
      this.searchArray = [
        { fields: this.taskForm.dateRange, name: '指派日期', id: '1', checked: true, show: true, isDisabled: true },
        { fields: this.taskForm.finishDateRange, name: '完成日期', id: '22', checked: true, show: true },
        { fields: this.taskForm.number, name: '订单号', id: '2', checked: true, show: true },
        { fields: this.taskForm.workOrderNum, name: '工单号', id: '3', checked: false, show: false },
        { fields: this.taskForm.troubleDescrible, name: '任务描述', id: '21', checked: false, show: true, isClearable: true },
        { fields: this.taskForm.repairMan, name: '申请人', id: '4', checked: true, show: true },
        { fields: this.taskForm.customerDept, name: '报修部门', id: '5', checked: false, show: true },
        { fields: this.taskForm.person, name: '联系人', id: '6', checked: false, show: true },
        { fields: this.taskForm.contactWay, name: '联系方式', id: '7', checked: false, show: true },
        { fields: this.taskForm.address, name: '联系地址', id: '8', checked: false, show: true },
        { fields: this.taskForm.customer, name: '客户', id: '9', checked: false, show: false },
        { fields: this.taskForm.servicerDept, name: '服务部门', id: '10', checked: false, show: true },
        { fields: this.taskForm.designee, name: '指派人', id: '11', checked: false, show: true },
        { fields: this.taskForm.dealWay, name: '处理方式', id: '12', checked: false, show: true },
        { fields: this.stage === 4 ? this.taskForm.orderStatus : this.taskForm.taskStatus, name: this.stage === 4 ? '订单状态' : '任务状态', id: '13', checked: false, show: false, type: this.stage },
        { fields: this.taskForm.logistics, name: '寄出物流', id: '15', checked: false, show: false },
        { fields: this.taskForm.logisticsNumber, name: '寄出单号', id: '16', checked: false, show: false },
        { fields: this.taskForm.faultType, name: '故障类型', id: '17', checked: false, show: false },
        { fields: this.taskForm.faultPhenomenon, name: '故障现象', id: '18', checked: false, show: false },
        { fields: this.taskForm.tag, name: '标签', id: '19', checked: false, show: false },
      ];
    }
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });

    setTimeout(() => {
      this.handleSearch();
    });
  }
  mounted() {
    if (this.stage === 4) {
      // this.itemData.work_order_num.hidden = !checkPermissionCompany(UserModule.getCompanyId, Type.workOrderNum);
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '3') {
          this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.workOrderNum);
        }
      }
    }
    if (this.stage === 1 || this.stage === 3 || this.stage === 4) {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '13') {
          this.searchArray[i].type = this.stage
          this.searchArray[i].show = true
          this.searchArray[i].name = this.stage === 4 ? '订单状态' : '任务状态'
        }
      }
    } else {
      for (let i = 0; i < this.searchArray.length; i++) {
        if (this.searchArray[i].id === '13') {
          this.searchArray[i].show = false
        }
      }
    }
    for (let i = 0; i < this.searchArray.length; i++) {
      if (this.searchArray[i].id === '9') { // 客户
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
      }
      if (this.searchArray[i].id === '15') { // 寄出物流
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.TASK_SEND);
      }
      if (this.searchArray[i].id === '16') { // 基础单号
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.TASK_SEND);
      }
      if (this.searchArray[i].id === '17') { // 故障类型
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.fault);
      }
      if (this.searchArray[i].id === '18') { // 故障现象
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.FAULT_PHENOMENON);
      }
      if (this.searchArray[i].id === '19') { // 标签
        this.searchArray[i].show = checkPermissionCompany(UserModule.getCompanyId, Type.tag);
      }
      if (this.searchArray[i].id === '22') { // 完成日期 仅所有任务、已完成显示
        this.searchArray[i].show = this.stage === 1 || this.stage === 4;
      }
    }
    // this.itemData.customer.hidden = !checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
    // this.itemData.logistics.hidden = !checkPermissionCompany(UserModule.getCompanyId, Type.TASK_SEND);
    // this.itemData.logistics_number.hidden = !checkPermissionCompany(UserModule.getCompanyId, Type.TASK_SEND);
  }
  getManyDays() {
    let yyyy = 365;
    let y = new Date().getFullYear();
    let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
    if (flag) {
      yyyy = 366;
    }
    return yyyy;
  }

  private orderFormReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.taskForm.dateRange = val.fields;
        break;
      case '22':
        this.taskForm.finishDateRange = val.fields;
        break;
      case '2':
        this.taskForm.number = val.fields;
        break;
      case '3':
        this.taskForm.workNumber = val.fields;
        break;
      case '21':
        this.taskForm.troubleDescrible = val.fields;
        break;
      case '4':
        this.taskForm.repairMan = val.fields;
        break;
      case '5':
        this.taskForm.customerDept = val.fields;
        break;
      case '6':
        this.taskForm.person = val.fields;
        break;
      case '7':
        this.taskForm.contactWay = val.fields;
        break;
      case '8':
        this.taskForm.address = val.fields;
        break;
      case '9':
        this.taskForm.customer = val.fields;
        break;
      case '10':
        this.taskForm.servicerDept = val.fields;
        break;
      case '11':
        this.taskForm.designee = val.fields;
        break;
      case '12':
        this.taskForm.dealWay = val.fields;
        break;
      case '13':
        if (this.stage === 4) {
          this.taskForm.orderStatus = val.fields;
        } else {
          this.taskForm.taskStatus = val.fields;
        }
        break;
      case '15':
        this.taskForm.logistics = val.fields;
        break;
      case '16':
        this.taskForm.logisticsNumber = val.fields;
        break;
      case '17':
        this.taskForm.faultType = val.fields;
        break;
      case '18':
        this.taskForm.faultPhenomenon = val.fields;
        break;
      case '19':
        this.taskForm.tag = val.fields;
        break
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  // 点击搜索
  handleSearch() {
    const startTime = this.taskForm.dateRange[0] / 1000;
    const endTime = this.taskForm.dateRange[1] / 1000 + 86400;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      order_num: this.taskForm.number,
      start_time: startTime,
      end_time: endTime,
      order_task_finish_start_time: this.taskForm.finishDateRange ? this.taskForm.finishDateRange[0] / 1000 : '',
      order_task_finish_end_time: this.taskForm.finishDateRange ? this.taskForm.finishDateRange[1] / 1000 + 86400 : '',
      trouble_describle: this.taskForm.troubleDescrible,
      create_user_name: this.taskForm.repairMan,
      customer_dept_id: this.taskForm.customerDept.id ? this.taskForm.customerDept.id : '',
      name: this.taskForm.person,
      mobile: this.taskForm.contactWay,
      address: this.taskForm.address,
      servicer_dept_id: this.taskForm.servicerDept.id,
      assign_user_name: this.taskForm.designee,
      deal_type: this.taskForm.dealWay,
      armed_state: this.taskForm.taskStatus,
      order_state: this.taskForm.orderStatus,
      send_express_name: this.taskForm.logistics,
      send_express_number: this.taskForm.logistics_number,
      work_order_num: this.taskForm.workOrderNum,
      fault_id: this.taskForm.faultType ? this.taskForm.faultType.id : '',
      fault_phenomenon_id: this.taskForm.faultPhenomenon ? this.taskForm.faultPhenomenon.id : '',
      tags_ids: this.taskForm.tag ? this.taskForm.tag.id : '',
    };
    // if (this.taskForm.customer && parseInt(this.taskForm.customer.customer_type) === 1) {
    //   params.customer_company_id = this.taskForm.customer.customer_company_id;
    // } else {
    //   if (this.taskForm.customer) {
    //     params.customer_user_id = this.taskForm.customer.customer_user_id;
    //   }
    // }
    if (this.taskForm.customer){
      params.customer_company_id =   this.taskForm.customer.id ? this.taskForm.customer.id : "";
    }
    eventBus.$emit('orderTaskSearch', params);
  }
  // 清空搜索条件
  handleClearSearch() {
    this.taskForm = {
      number: '',
      dateRange: [new Date().getTime() - 1000 * 60 * 60 * 24 * this.getManyDays(), new Date().getTime()],
      finishDateRange: '',
      troubleDescrible:'',
      repairMan: '',
      customerDept: {},
      person: '',
      contactWay: '',
      address: '',
      customer: {},
      servicerDept: {},
      designee: '',
      dealWay: '',
      taskStatus: '',
      orderStatus: '',
      logistics: '',
      logisticsNumber: '',
      workOrderNum: '',
      faultType: '',
      faultPhenomenon: '',
      tag: '',
    };
    for (let p = 0; p < this.searchArray.length; p++) {
      if (this.searchArray[p].id === '1') {
        this.searchArray[p].fields = [new Date().getTime() - 1000 * 60 * 60 * 24 * this.getManyDays(), new Date().getTime()]
      } else {
        this.searchArray[p].fields = ''
      }
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      start_time: this.taskForm.dateRange[0] / 1000,
      end_time: this.taskForm.dateRange[1] / 1000 + 86400
    };
    eventBus.$emit('orderTaskSearch', params);
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
